document.cookie = 'post-protection=1; expires=' + (new Date(new Date().getTime() + (86400 * 7 * 1000))).toGMTString() + '; path=/; secure; samesite=none';

$(document).ready(function () {

	let htmlIdAttribute = $('html').attr('id');

	$('#frm-schoolCampReservationForm-cardCount').change(function () {
		$('#valueCardCount').text(this.value)
	})

	if (htmlIdAttribute !== 'reservation-school' && htmlIdAttribute !== 'reservation-camp') {
		return;
	}
	else {

		$('input[name="cardCount"]').on('change', function () {
			let formData = new FormData($('form[data-ajax-action]')[0]);
			formData.delete('_do');
			$.ajax({
				type:        "POST",
				url:         $('form[data-ajax-action]').data('ajax-action'),
				data:        formData,
				cache:       false,
				contentType: false,
				processData: false,
			}).done(function (data) {
				console.log(data)
				Object.keys(data.snippets).forEach(function (key) {
					$('#' + key).html(data.snippets[key]);
				})
			});
		})

	}
})